import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { DashboardService } from '../../../services/dashboard.service';
import { BreakdownAnalysisResponse } from '../../../../maintenance/maintenance-overview/models/maintenance-overview.model';
import { ErrorHandlerService } from '../../../../../_shared/services/error-handler.service';
import { BreakdownAnalysisTableComponent } from '../../../../_shared/components/breakdown-analysis-table/breakdown-analysis-table.component';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-maintenance-required-breakdown-modal',
  standalone: true,
  imports: [CommonModule, BreakdownAnalysisTableComponent, TranslocoPipe],
  templateUrl: './maintenance-required-breakdown-modal.component.html',
  styleUrl: './maintenance-required-breakdown-modal.component.scss'
})
export class MaintenanceRequiredBreakdownModalComponent implements OnInit {
  isLoading: boolean = false;
  data: BreakdownAnalysisResponse[] = [];

  private dashboardService = inject(DashboardService);
  private errorService = inject(ErrorHandlerService);
  private readonly transloco = inject(TranslocoService);
  private cancelSubject = new Subject<void>();

  constructor(private activeModal: NgbActiveModal) { }

  async ngOnInit(): Promise<void> {
    await this.loadData();
  }

  async loadData(): Promise<void> {
    this.isLoading = true;

    try {
      // TODO: Implement actual API call when ready
      // const request = {
      //   accountIds: [],
      //   timeFrom: new Date(),
      //   timeTo: new Date()
      // };
      // const response = await this.dashboardService.getMaintenanceRequiredBreakdown(request, this.cancelSubject);
      // if (response.data) {
      //   this.data = response.data;
      // }

      // Mock data based on the provided image
      this.data = [
        {
          factor: this.transloco.translate('maintenanceDashboard.breakdownFactors.totalVehicles'),
          previousValue: '50',
          currentValue: '55',
          change: '+10%',
          impactOnEfficiency: 'Increased on Efficiency'
        },
        {
          factor: this.transloco.translate('maintenanceDashboard.breakdownFactors.totalFuelUsed'),
          previousValue: '10 250 000 km',
          currentValue: '275 000 km',
          change: '-10%',
          impactOnEfficiency: 'Increased on Efficiency'
        },
        {
          factor: this.transloco.translate('maintenanceDashboard.breakdownFactors.averageSpeed'),
          previousValue: '80km/h',
          currentValue: '80km/h',
          change: '0%',
          impactOnEfficiency: 'Stable'
        },
        {
          factor: this.transloco.translate('maintenanceDashboard.breakdownFactors.idleTimeHours'),
          previousValue: '1 hr',
          currentValue: '3 hr',
          change: '+2 hrs',
          impactOnEfficiency: 'Decreased on Efficiency'
        },
        {
          factor: this.transloco.translate('maintenanceDashboard.breakdownFactors.harshAcceleration'),
          previousValue: '10 per 100 km',
          currentValue: '15 per 100 km',
          change: '+50%',
          impactOnEfficiency: 'Decreased on Efficiency'
        },
        {
          factor: this.transloco.translate('maintenanceDashboard.breakdownFactors.engineConditionScore'),
          previousValue: '85',
          currentValue: '78',
          change: '+10%',
          impactOnEfficiency: 'Decreased on Efficiency'
        },
        {
          factor: this.transloco.translate('maintenanceDashboard.breakdownFactors.totalDistance'),
          previousValue: '250 000 km',
          currentValue: '275 000 km',
          change: '+10%',
          impactOnEfficiency: 'Decreased on Efficiency'
        },
        {
          factor: this.transloco.translate('maintenanceDashboard.breakdownFactors.driverEfficiencyScore'),
          previousValue: '85%',
          currentValue: '78%',
          change: '-8.24%',
          impactOnEfficiency: 'Increased on Efficiency'
        }
      ];

      this.isLoading = false;
    } catch (error) {
      this.errorService.handleError(error, {
        callback: () => {
          this.isLoading = false;
        }
      });
    }
  }

  closeModal(): void {
    this.cancelSubject.next();
    this.cancelSubject.complete();
    if (this.activeModal) {
      this.activeModal.close();
    }
  }
}